<div class="d-flex justify-content-center indicator-container" *ngIf="applicationReady$ && user && user.isImpersonating">
  <span class="d-flex align-items-center indicator">
    You are currently impersonating <strong class="ml-1">{{ user.firstName | titlecase }} {{ user.lastName | titlecase }}</strong>
    <button pButton type="button" class="ml-1 ml-lg-4" label="Stop" (click)="stopImpersonate()"></button>
  </span>
</div>
